import { Card, CardActionArea, CardContent, Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import JobOfferingDto from '../model/jobOfferingDto';
import theme from '../theme/theme';

// Card look of phatconsulting.de: white, square, no shadow; bold caps label, dotted LED title.
const useStyles = makeStyles(() => ({
  // Hover as on the previous phat.careers: card grows a little, turns PHAT green, text white.
  card: {
    background: '#fff',
    height: '100%',
    borderRadius: 0,
    boxShadow: 'none',
    transition: 'transform 0.4s, background-color 0.4s',
    '&:hover': {
      transform: 'scale3d(1.05, 1.05, 1)',
      backgroundColor: theme.palette.secondary.light,
    },
    '&:hover $content, &:hover $more': {
      color: '#fff',
    },
  },
  content: {
    width: '100%',
    padding: '16px !important',
    color: '#344853',
    transition: 'color 0.4s',
  },
  label: {
    fontFamily: 'DIN2014-Bold, Helvetica, Arial, sans-serif',
    fontSize: '18px',
    textTransform: 'uppercase',
    marginBottom: '8px',
  },
  title: {
    fontFamily: 'LedRegular, Arial, sans-serif',
    fontSize: '29.25px',
    lineHeight: 1.15,
  },
  more: {
    fontFamily: 'DIN2014-Regular, Helvetica, Arial, sans-serif',
    fontSize: '18px',
    marginTop: '16px',
    color: '#344853',
    transition: 'color 0.4s',
  },
}));

type JobOfferingCardProps = {
  jobOffering?: JobOfferingDto;
};

const JobOfferingCard = ({ jobOffering }: JobOfferingCardProps): JSX.Element => {
  const classes = useStyles();

  return (
    <Grid md={4} sm={6} xs={12} item>
      <Card className={classes.card}>
        <CardActionArea href={jobOffering?.JobAdUrl} style={{ height: '100%', alignItems: 'flex-start', display: 'flex' }}>
          <CardContent className={classes.content}>
            <Typography className={classes.label} component="div">
              {jobOffering?.ShortDescription}
            </Typography>
            <Typography className={classes.title} component="h2">
              {jobOffering?.Title}
            </Typography>
            <Typography className={classes.more}>Mehr erfahren &rarr;</Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    </Grid>
  );
};

export default JobOfferingCard;
